import styled from "@emotion/styled";
import React from "react";
import {useSelector} from "react-redux";
import {getContestCorrectAnswers, getContestGameBar} from "modules/selectors";
import {getDashedValue} from "modules/utils/helpers";
import {useTranslation} from "react-i18next";
import {HOCSecretKey} from "components/HOC";

const Wrapper = styled.div`
	margin-top: 16px;
	-webkit-border-radius: 8px;
	-moz-border-radius: 8px;
	border-radius: 8px;
`;

const TopBlock = styled.div`
	-webkit-border-radius: 8px 8px 0 0;
	-moz-border-radius: 8px 8px 0 0;
	border-radius: 8px 8px 0 0;
	background: ${({theme}) => theme.summaryCard.final.background};
	color: ${({theme}) => theme.summaryCard.final.color};

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	padding: 8px;

	p {
		font-style: normal;
		font-weight: 600;
		font-size: 14px;
		line-height: 16px;
		text-align: center;
	}

	h2 {
		font-style: normal;
		font-weight: 700;
		font-size: 28px;
		margin-top: 5px;
		line-height: 100%;
		text-align: center;
		font-feature-settings: "liga" off, "calt" off;
	}
`;
const AvgBlock = styled.div`
	background: ${({theme}) => theme.summaryCard.final.avgBackground};
	-webkit-border-radius: 0 0 8px 8px;
	-moz-border-radius: 0 0 8px 8px;
	border-radius: 0 0 8px 8px;

	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;

	span {
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;
		color: ${({theme}) => theme.colors.text.white};
		text-transform: capitalize;

		b {
			font-weight: 700;
			font-size: 16px;
			line-height: 16px;
			color: ${({theme}) => theme.colors.text.white};
		}
	}
`;

export const SummaryTotalCard: React.FC = () => {
	const {t} = useTranslation();
	const finalScore = useSelector(getContestCorrectAnswers);
	const gameBar = useSelector(getContestGameBar);
	return (
		<Wrapper>
			<TopBlock>
				<p>{t("page.summary.final_score")}</p>
				<HOCSecretKey>
					<h2>{getDashedValue(finalScore)}</h2>
				</HOCSecretKey>
			</TopBlock>
			<AvgBlock>
				<span>
					{t("page.summary.avg_score")}: <b>{getDashedValue(gameBar?.avgToday)}</b>
				</span>
			</AvgBlock>
		</Wrapper>
	);
};
